<template>
  <div class="product is-gray">
    <div class="image d-flex align-items-center justify-content-center">
      <a :href="getUrl(item)">
        <img
          :src="item.imageUrl"
          :alt="localize(item.names)"
          class="img-fluid"
          onerror="this.src = '/images/comingsoon.png'"
          style="max-height: 220px"
        />
      </a>
      <div
        class="hover-overlay d-flex align-items-center justify-content-center"
      >
        <div class="CTA d-flex align-items-center justify-content-center">
          <!--<a href=""class="add-to-cart"><i class="fa fa-shopping-cart"></i></a>-->
          <a :href="getUrl(item)" class="visit-product active"
            ><i class="icon-search"></i>{{ $t('View') }}</a
          >
          <!--<a href=""data-toggle="modal" data-target="#exampleModal" class="quick-view"><i class="fa fa-arrows-alt"></i></a>-->
        </div>
      </div>
    </div>
    <div class="title">
      <a :href="getUrl(item)">
        <h3 class="h6 text-uppercase no-margin-bottom">
          {{ localize(item.names) }}
        </h3>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { localize as genLocalize } from '../common/localize';
import type { StyleWithPrint } from '../common/CatalogItem';

const props = defineProps<{
  item?: StyleWithPrint;
  culture?: string;
  styleId?: string;
}>();

function getUrl(design: StyleWithPrint): string {
  return '/noncustom/item/' + design.id + '/' + props.styleId;
}

function localize(dict: Record<string, string>) {
  return genLocalize(props.culture, dict);
}
</script>

<style scoped></style>
